// Debug mode puts a mote on a temporary accelerated config. The backend rejects any PUT
// carrying these keys while it is active and fails the whole request, so both the detail
// view and the grouped/bulk view drop them before saving rather than losing the edit.
export const DEBUG_MODE_BLOCKED_KEYS = [
  'measurement_settings',
  'reporting',
  'aggressive_measurement',
  'aggressive_measurement_timeout'
];

// Detail view: one device, so the blocked keys are removed and the rest of the edit goes through.
export const stripDebugModeKeys = (payload) => {
  if (!payload) return payload;
  const stripped = { ...payload };
  DEBUG_MODE_BLOCKED_KEYS.forEach((key) => { delete stripped[key]; });
  return stripped;
};

// List rows carry debug_mode_active (a plain boolean); the detail endpoint's
// debug_mode is an object, so the two are deliberately named apart.
export const getDebugModeSerials = sensorList => (sensorList || [])
  .filter(s => s && s.debug_mode_active)
  .map(s => s.serial_number);

// Grouped view: one payload covers many devices, so the debug-mode ones are dropped from the
// serial list and everyone else still gets the edit. Returns null when nothing is left to send.
export const excludeDebugModeSerials = (payload, debugSerials) => {
  if (!payload) return payload;
  if (!DEBUG_MODE_BLOCKED_KEYS.some(key => key in payload)) return payload;
  if (!debugSerials || debugSerials.length === 0) return payload;
  const serials = [].concat(payload.serial_number || [])
    .filter(sn => !debugSerials.includes(sn));
  if (serials.length === 0) return null;
  return { ...payload, serial_number: serials };
};
